const maxlengths = {
  Applications: {
    app_id: 26,
    app_code: 3,
    order_no: 20,
    estimate_no: 20,
    mail: 255,
    word: 511,
    memo: 511,
    license_no: 40,
    support_service_no: 40,
    customer_code: 16,
    end_org_name: 255,
    end_org_kana: 255,
    end_search_org_name: 511,
    end_representative_name: 255,
    end_representative_kana: 255,
    end_dept_name: 255,
    end_search_dept_name: 511,
    end_chrg_name: 255,
    end_chrg_kana: 255,
    end_tel: 63,
    end_search_tel: 127,
    end_fax: 63,
    end_zipcode: 63,
    end_address: 511,
    end_email: 255,
    partner_org_name: 255,
    partner_org_kana: 255,
    partner_search_org_name: 511,
    partner_representative_name: 255,
    partner_representative_kana: 255,
    partner_dept_name: 255,
    partner_search_dept_name: 511,
    partner_chrg_name: 255,
    partner_chrg_kana: 255,
    partner_tel: 63,
    partner_search_tel: 127,
    partner_fax: 63,
    partner_zipcode: 63,
    partner_address: 511,
    partner_email: 255,
    notes: 2000,
    creator_ip: 15,
    changer_ip: 15
  },
  AppLicenseSupports: {
    editions: 127,
    editions_other: 255,
    categories: 127,
    categories_other: 255,
    trial_key_usage_flg: 1,
    data_migration_request_flg: 1,
    trial_key: 64,
    as_edition: 1,
    as_neo_license_count: 9,
    as_license_no: 40,
    add_expenses_edition: 1,
    add_expenses_category: 1,
    add_expenses_license_no: 40,
    upd_expenses_edition: 1,
    upd_expenses_category: 1,
    upd_expenses_support_service_no: 40,
    db: 1,
    db_other: 255,
    os: 1,
    os_other: 255,
    delivery_destination: 1,
    org_name_en: 255,
    zipcode_en: 63,
    address_en: 511
  },
  AppServiceRequests: {
    editions: 127,
    editions_other: 255,
    categories: 127,
    categories_other: 255
  },
  AppNeoMigrations: {
    user_count: 9,
    delivery_address_org_name: 255,
    delivery_address_dept_name: 255,
    delivery_address_chrg_name: 255,
    delivery_address_tel: 63,
    delivery_address_fax: 63,
    delivery_address_zipcode: 63,
    delivery_address_address: 511,
    delivery_address_email: 255
  },
  AppLicenseAdditions: {
    product: 1,
    product_other: 255,
    c1_license_no: 40,
    c1_user_count: 9,
    c2_license_no: 40,
    c2_user_count: 9,
    has_other_apps: 1,
    base_contract: 1,
    total_user_count: 9,
    os_db_type: 255
  },
  AppLicenseSubtractions: {
    product: 1,
    product_other: 255,
    c1_license_no: 40,
    c1_user_count: 9,
    has_other_apps: 1,
    user_count_after: 9,
    os_db_type: 255
  },
  AppCustomers: {
    change_target: 1024
  }
}

export const {
  Applications,
  AppLicenseSupports,
  AppServiceRequests,
  AppNeoMigrations,
  AppLicenseAdditions,
  AppLicenseSubtractions,
  AppCustomers
} = maxlengths



// WEBPACK FOOTER //
// ./src/config/maxlengths.js